import clsx from 'clsx';
import React, { FC, ReactNode, useState } from 'react';
import { ChevronUp } from 'react-ionicons';

interface DesignerItemProps {
  children: ReactNode;
  icon: ReactNode;
  title: string;
}

const DesignerItem: FC<DesignerItemProps> = ({ children, icon, title }) => {
  const [open, setOpen] = useState(false);
  const onChange = () => setOpen((prev) => !prev);
  return (
    <div className="w-full rounded bg-background-base-surface-2 p-4">
      <div
        className="flex cursor-pointer items-center justify-between gap-1"
        onClick={onChange}
      >
        <div className="flex gap-2 text-content-base-default">
          <span>{icon}</span> <p className="font-bold">{title}</p>
        </div>
        <span className={clsx({ 'rotate-180': !open })}>
          <ChevronUp width="20px" height="20px" color="currentColor" />
        </span>
      </div>
      {open && <div className="mt-6">{children}</div>}
    </div>
  );
};

export default DesignerItem;
